const frCA= {
    login: {
      title: 'Se connecter',
      sign_in_btn: 'Se connecter'
    },
    bar: {
        logout: 'Se déconnecter',
        languages: 'Langues',
        settings: 'Ouvrir les paramètres'
    },
    language: {
      name: 'Français (Canada)',
    },
    attributePage: {
        title: 'Modifications d’attributs',
        viewChanges: 'Voir les modifications',
        dateTime: 'Date',
        notificationType: 'Type de notification',
        notificationValue: 'Valeur de la notification',
        oldValue: 'Ancienne valeur',
        newValue: 'Nouvelle valeur',
        accept: 'Accepter',
        reject: 'Rejeter',
    },
    Home: 'Accueil',
    load: 'Exécution du chargement initial...',
    Requested: "Demandé",
    Viewed: "Consulté",
    Executing: "En cours d’exécution",
    Completed: "Complété",
    Expired: "Expiré",
    Cancelled: "Annulé",
    Error: "Erreur",
    Rejected: "Rejeté",
    error: 'Un problème est survenu; veuillez réessayer plus tard.',
    displayname: 'Nom affiché',
    givenname: 'Prénom',
    surname: 'Nom',
    email: 'Courriel',
    mail: 'Courriel',
    name: 'Prénom',
    firstname: 'Prénom',
    lastname: 'Nom',
    footer_copyright: 'Tous droits réservés.'
  };
  
  export default frCA;
  